import { Button, Modal, Spinner } from "react-bootstrap";

import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import box from "../../../Assets/Images/Souvenir/box.png";
import delivery from "../../../Assets/Images/Souvenir/delivery.png";
import four from "../../../Assets/Images/Souvenir/four.png";
import one from "../../../Assets/Images/Souvenir/one.png";
import three from "../../../Assets/Images/Souvenir/three.png";
import two from "../../../Assets/Images/Souvenir/two.png";

import PaymentSuccessfulModal from "../PaymentSuccessfulModal/PaymentSuccessfulModal";
import PaymentUnsuccessfulModal from "../PaymentUnsuccessfulModal/PaymentUnsuccessfulModal";
import "./StarShowcaseModal.css";
import PaymentModal1 from "../../../components/Modal/PaymentModal/PaymentModal1";
import { usePaytm } from "../../../CustomHooks/usePaytm";
import axios from "axios";
import { serverInfo } from "../../../App";
import MyVerticallyCenteredModal from "../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import { LocationContext } from "../../../CustomHelper/Helper";

const StarShowcaseModal = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [modalShowPay, setModalShowPay] = useState(false);
  const [successShow, setSuccessShow] = useState(false);
  const [unSuccessShow, seUnSuccessShow] = useState(false);

  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const paymentHideModalFun = (data) => {
    setModalShowPay(data);
  };

  const handleModel = () => {
    setModalShowPay(true);
  };
  const handleInvoice = () => {};
  const dataModelPayment = (data) => {
    setModalShowPay(data);
  };

  const handleSouvenir = () => {
    let souvinerData = {
      souvenir_create_id: props.souvenir?.souvenir_id,
      souvenir_apply_id: props.souvenir?.id,
      total_amount: props.souvenir?.total_amount,
    };

    axios.post(`/api/user/souviner/payment/store`, souvinerData).then((res) => {
      if (res.data.status === 200) {
        handleModel();
      }
    });
  };

  return (
    <div className="">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName=""
        centered
      >
        <Modal.Body className="modalShowcaseParent">
          <div className="p-4">
            <div className="d-flex justify-content-between">
              <h2 className="headingStatus">Souvenir Status</h2>
              <div className="">
                <button className="close-button" onClick={props.onHide}>
                  X
                </button>
              </div>
            </div>

            <div className="underlineBlack"></div>

            {!props.loading ? (
              <>
                <h5 className="text-white justify-content-center text-center mx-auto souvinerStyle">
                  <div className="greetingsHeight d-flex justify-content-center align-items-center">
                    <Spinner
                      animation="border"
                      variant="warning"
                      className="souvinerStyle"
                      style={{
                        height: "100px",
                        width: "100px",
                        border: "10px dashed",
                        margin: "150px 0",
                      }}
                    />
                  </div>
                </h5>
              </>
            ) : (
              <>
                <div className="row my-4">
                  <div className="col-md-5 my-2">
                    <img
                      src={imageCdnUrl + props?.souvenir?.image}
                      className="img-fluid w-100"
                      alt=""
                    />
                  </div>
                  <div className="col-md-7 my-2">
                    <div className="text-light">
                      <h6>Name</h6>
                      <p>{props.souvenir?.name}</p>
                    </div>
                    <div className="text-light">
                      <h6>Mobile No</h6>
                      <p>{props.souvenir?.mobile_no}</p>
                    </div>
                    <div className="text-light">
                      <h6>Address</h6>
                      <p>
                        {props.souvenir?.area}, {props.souvenir.city?.name},{" "}
                        {props.souvenir.state?.name},{" "}
                        {props.souvenir.country?.name}
                      </p>
                    </div>
                    <div className="text-light">
                      <h6>Total Price</h6>
                      <p>
                        {paymentCountWithSymbol(props?.souvenir?.total_amount)}
                      </p>
                    </div>
                    <div className="text-light">
                      <h6>Short Description</h6>
                      <p>{props.souvenir?.description}</p>
                    </div>
                  </div>
                </div>

                <div className="newDeliveryMain d-flex justify-content-center mt-4">
                  <div className="">
                    <div className="BoxR mx-3 btn-success text-light p-2">
                      <img src={one} alt="" className="DeliveryImgCopy p-1" />
                    </div>
                    <p className="text-light text-center PSize">Applied</p>
                  </div>
                  <span className="Box-Line"></span>

                  <div className="">
                    {Number(props.souvenir?.status) >= 2 ? (
                      <div className="BoxR  mx-3 btn-success text-light p-2">
                        <img src={two} alt="" className="DeliveryImgCopy p-1" />
                      </div>
                    ) : (
                      <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                        <img src={two} alt="" className="DeliveryImgCopy p-1" />
                      </div>
                    )}
                    <p className="text-light text-center PSize">Approve</p>
                  </div>
                  <span className="Box-Line"></span>

                  <div className="">
                    {Number(props.souvenir?.status) >= 3 ? (
                      <div className="BoxR  mx-3 btn-success text-light p-2">
                        <img
                          src={three}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    ) : (
                      <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                        <img
                          src={three}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    )}
                    <p className="text-light text-center PSize">Processing</p>
                  </div>
                  <span className="Box-Line"></span>

                  <div className="">
                    {Number(props.souvenir?.status) >= 4 ? (
                      <div className="BoxR  mx-3 btn-success text-light  py-2 d-flex justify-content-center">
                        <img
                          src={three}
                          alt=""
                          className="DeliveryImgCopy py-1"
                        />
                      </div>
                    ) : (
                      <div className="BoxR PenColBg mx-3 btn-warning text-light  py-2 d-flex justify-content-center">
                        <img
                          src={box}
                          alt=""
                          className="DeliveryImgCopy py-1"
                        />
                      </div>
                    )}
                    <p className="text-light text-center PSize">
                      Product Received
                    </p>
                  </div>
                  <span className="Box-Line"></span>

                  <div className="">
                    {Number(props.souvenir?.status) >= 5 ? (
                      <div className="BoxR  mx-3 btn-success text-light p-2">
                        <img
                          src={three}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    ) : (
                      <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                        <img
                          src={three}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    )}
                    <p className="text-light text-center PSize">Processing</p>
                  </div>
                  <span className="Box-Line"></span>

                  <div className="">
                    {Number(props.souvenir?.status) >= 6 ? (
                      <div className="BoxR  mx-3 btn-success text-light p-2">
                        <img
                          src={three}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    ) : (
                      <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                        <img
                          src={delivery}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    )}
                    <p className="text-light text-center PSize">
                      Out for Delivery
                    </p>
                  </div>
                  <span className="Box-Line"></span>

                  <div className="">
                    {Number(props.souvenir?.status) === 7 ? (
                      <div className="BoxR mx-3 btn-success text-light p-2">
                        <img
                          src={four}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    ) : (
                      <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                        <img
                          src={four}
                          alt=""
                          className="DeliveryImgCopy p-1"
                        />
                      </div>
                    )}
                    <p className="text-light text-center PSize">Delivered</p>
                  </div>
                </div>

                <div className="newDelivery d-flex justify-content-center mt-4">
                  <div className="row">
                    <div className="col-md-7 d-flex justify-content-center">
                      <div className="">
                        <div className="BoxR mx-3 btn-success text-light p-2">
                          <img
                            src={one}
                            alt=""
                            className="DeliveryImgCopy p-1"
                          />
                        </div>
                        <p className="text-light text-center PSize">Applied</p>
                      </div>

                      <div className="">
                        {Number(props.souvenir?.status) >= 2 ? (
                          <div className="BoxR  mx-3 btn-success text-light p-2">
                            <img
                              src={two}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        ) : (
                          <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                            <img
                              src={two}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        )}
                        <p className="text-light text-center PSize">Approve</p>
                      </div>
                      <div className="">
                        {Number(props.souvenir?.status) >= 3 ? (
                          <div className="BoxR  mx-3 btn-success text-light p-2">
                            <img
                              src={three}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        ) : (
                          <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                            <img
                              src={three}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        )}
                        <p className="text-light text-center PSize">
                          Processing
                        </p>
                      </div>

                      <div className="">
                        {Number(props.souvenir?.status) >= 4 ? (
                          <div className="BoxR  mx-3 btn-success text-light  py-2 d-flex justify-content-center">
                            <img
                              src={three}
                              alt=""
                              className="DeliveryImgCopy py-1"
                            />
                          </div>
                        ) : (
                          <div className="BoxR PenColBg mx-3 btn-warning text-light  py-2 d-flex justify-content-center">
                            <img
                              src={box}
                              alt=""
                              className="DeliveryImgCopy py-1"
                            />
                          </div>
                        )}
                        <p className="text-light text-center PSize">
                          Product Received
                        </p>
                      </div>
                    </div>
                    <div className="col-md-5 d-flex justify-content-center">
                      <div className="">
                        {Number(props.souvenir?.status) >= 5 ? (
                          <div className="BoxR  mx-3 btn-success text-light p-2">
                            <img
                              src={three}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        ) : (
                          <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                            <img
                              src={three}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        )}
                        <p className="text-light text-center PSize">
                          Processing
                        </p>
                      </div>

                      <div className="">
                        {Number(props.souvenir?.status) >= 6 ? (
                          <div className="BoxR  mx-3 btn-success text-light p-2">
                            <img
                              src={three}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        ) : (
                          <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                            <img
                              src={delivery}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        )}
                        <p className="text-light text-center PSize">
                          Out for Delivery
                        </p>
                      </div>

                      <div className="">
                        {Number(props.souvenir?.status) === 7 ? (
                          <div className="BoxR mx-3 btn-success text-light p-2">
                            <img
                              src={four}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        ) : (
                          <div className="BoxR PenColBg mx-3 btn-warning text-light p-2">
                            <img
                              src={four}
                              alt=""
                              className="DeliveryImgCopy p-1"
                            />
                          </div>
                        )}
                        <p className="text-light text-center PSize">
                          Delivered
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="d-flex justify-content-center">
              {/* onClick={() => setModalShowPay(true)} */}
              {Number(props.souvenir?.status) == 1
                ? payStatus && (
                    <Button
                      className="mx-3 btn-success"
                      onClick={handleSouvenir}
                      title="Payment Now"
                    >
                      <i className="fa-solid fa-money-check"></i>
                    </Button>
                  )
                : null}
              {Number(props.souvenir?.status) >= 2 ? (
                <Link to={`/souvenir/invoice/${props.souvenir?.id}`}>
                  <Button onClick={handleInvoice} title="Invoice Download">
                    <i className="fa fa-download"></i>
                  </Button>
                </Link>
              ) : null}
              {/* <Button onClick={() => setSuccessShow(true)}><i className="fa fa-download"></i></Button> */}
              {/* <Button onClick={() => seUnSuccessShow(true)}><i className="fa fa-download"></i></Button> */}
            </div>

            <MyVerticallyCenteredModal
              show={modalShowPay}
              onHide={() => setModalShowPay(false)}
              event_id={props.souvenir?.id}
              fee={paymentCount(props?.souvenir?.total_amount)}
              baseFee={props?.souvenir?.total_amount}
              event_type="souvenir"
              redirectTo="activities"
            />

            <PaymentSuccessfulModal
              show={successShow}
              onHide={() => setSuccessShow(false)}
            />
            <PaymentUnsuccessfulModal
              show={unSuccessShow}
              onHide={() => seUnSuccessShow(false)}
            />
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default StarShowcaseModal;
